module.exports = __webpack_public_path__ + "media/bootstrap-icons/bounding-box-b079215f.svg";